<template>
  <div class="iphone-top-config-progress" :class="{ 'iphone-top-config-progress--overlay': overlay }">
    <div class="text-h6 text-weight-medium q-mb-xs">
      {{ t('iphoneTopSetup.configuringTitle') }}
    </div>
    <div class="text-body2 text-grey-8 q-mb-md">
      {{ t('iphoneTopSetup.configuringSubtitle') }}
    </div>
    <q-linear-progress
      :indeterminate="indeterminate"
      :value="progressValue"
      color="primary"
      rounded
      size="8px"
      class="q-mb-sm"
    />
    <div v-if="message" class="text-body2 text-primary">
      {{ message }}
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { mapIphoneTopProgressMessage } from '@/utils/iphoneTopProgressHeuristic.js'

const props = defineProps({
  message: { type: String, default: '' },
  loading: { type: Boolean, default: false },
  overlay: { type: Boolean, default: false }
})

const { t } = useI18n()

const mapped = computed(() => mapIphoneTopProgressMessage(props.message))

const indeterminate = computed(() =>
  props.loading && (mapped.value.indeterminate || mapped.value.value == null)
)

const progressValue = computed(() => {
  if (!props.loading) {
    return mapped.value.value ?? 0
  }
  return mapped.value.value ?? 0
})
</script>

<style scoped lang="scss">
.iphone-top-config-progress--overlay {
  text-align: center;
  max-width: 320px;
  margin: 0 auto;
}
</style>
